import React, { Component } from "react";
import { Container, Row, Col, Modal, ModalBody, ModalHeader } from "reactstrap";

//Import Team Box
import TeamBox from "./team-box";

class AboutUs extends Component {
  state = {
    members: [
      {
        id: 1,
        name: "Liliana Flores",
        image: "assets/images/MisionYVision.png",
        post: "Terapeuta de Sanación Física, Emocional y Espiritual",
      },
    ],
    collageImages: [
      "assets/images/Collage/fgwikrZEbYQNOfMLkLqMDV2nOZD5sGYRZ8aOZlUc.jpg",
      "assets/images/Collage/PXGYAzeaC6x2FOWh7ZTbn2n9kzshSQV9PSSkMO8i.jpg",
      "assets/images/Collage/PYu1yjD6z8nvBCNPdtMCSq1RkUWexd7QudcHcvIu.jpg",
      "assets/images/Collage/CnR3k31UGj4xHDDlTihFZrwkJyWUUf4kUUBy8RjS.jpg",
      "assets/images/Collage/dP89kdjysTyUj4LhfOGdgjFai9OxpJyN0M2jmUo9.jpg",
      "assets/images/Collage/0Gnekn09B7q5arykHPjNW9kawgj3vKRk5MUOSwDU.jpg",
      "assets/images/Collage/C10.jpg",
      "assets/images/Collage/bkU3HWiyhadZJfG6xaIOyMKelWFFCdLBaqdx5iih.jpg",
      "assets/images/Collage/trRm7LOmIKFT3QF7857xECqP8c7k3dklKHyPFAz6.jpg",
      "assets/images/Collage/aEuWH5rEbXW0DH11NVFvgCcxh7uvFdk0MZWPTolD.jpg",
    ],
    modalOpen: false,
    modalImage: null,
  };

  toggleModal = (image) => {
    this.setState((prevState) => ({
      modalOpen: !prevState.modalOpen,
      modalImage: image || null,
    }));
  };

  render() {
    return (
      <React.Fragment>
        <section className="section" id="about">
          <Container>
            {/* Título y descripción */}
            <Row>
              <Col lg={{ size: 8, offset: 2 }}>
                <div className="about-title mx-auto text-center">
                  <h2 className="font-weight-light">Más de nuestros servicios</h2>
                  <div className="text-muted pt-4" style={{ textAlign: "center", color: "#555555" }}>
                    <p>
                      Capacitación A Personal Técnico, Introducción De Dispensarios (Parte Hidráulica Y Electrónica).
                    </p>
                    <p>
                      Capacitación A Personal Técnico en Programación De Dispensarios Y Equipos De Monitoreo Veeder Root.
                    </p>
                    <p>Diseño, Instalación, Mantenimiento de Auto abastos.</p>
                  </div>
                </div>
              </Col>
            </Row>

            {/* Imagen principal */}
            <Row className="mt-5 d-flex justify-content-center align-items-center">
              {this.state.members.map((member, key) => (
                <div key={key} className="d-flex justify-content-center align-items-center">
                  <img
                    src={member.image}
                    alt={member.name}
                    className="img-fluid"
                    style={{
                      borderRadius: "15px",
                      boxShadow: "0px 4px 8px rgba(0, 0, 0, 0.3)",
                    }}
                    onClick={() => this.toggleModal(member.image)} // Mostrar imagen al hacer clic
                  />
                </div>
              ))}
            </Row>

            {/* Collage de imágenes */}
            <Row className="mt-5">
              <Col>
                <div
                  className="collage-grid"
                  style={{
                    display: "grid",
                    gridTemplateColumns: "repeat(5, 1fr)",
                    gridGap: "10px",
                  }}
                >
                  {this.state.collageImages.map((image, index) => (
                    <img
                      key={index}
                      src={image}
                      alt={`collage-${index}`}
                      style={{
                        width: "100%",
                        height: "150px",
                        borderRadius: "10px",
                        objectFit: "cover",
                        boxShadow: "0px 4px 8px rgba(0, 0, 0, 0.3)",
                      }}
                      onClick={() => this.toggleModal(image)} // Mostrar imagen al hacer clic
                    />
                  ))}
                </div>
              </Col>
            </Row>
          </Container>

          {/* Modal para mostrar imagen completa */}
          <Modal isOpen={this.state.modalOpen} toggle={this.toggleModal} size="lg">
            <ModalHeader toggle={this.toggleModal}>Imagen Completa</ModalHeader>
            <ModalBody>
              <img
                src={this.state.modalImage}
                alt="Imagen ampliada"
                className="img-fluid"
                style={{
                  borderRadius: "15px",
                  boxShadow: "0px 4px 8px rgba(0, 0, 0, 0.3)",
                }}
              />
            </ModalBody>
          </Modal>
        </section>
      </React.Fragment>
    );
  }
}

export default AboutUs;


